import React from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { PhoneAndroid, Email } from '@mui/icons-material';
import './MfaMethodSelector.scss';

interface MfaMethodSelectorProps {
  userEmail: string;
  onSelectTotp: () => void;
  onSelectEmail: () => void;
  onCancel?: () => void;
}

const MfaMethodSelector: React.FC<MfaMethodSelectorProps> = ({ userEmail, onSelectTotp, onSelectEmail, onCancel }) => (
  <Box className="mfa-method-selector">
    <Typography variant="h5" gutterBottom>
      Choose Your MFA Method
    </Typography>
    <Typography variant="body2" color="textSecondary" className="mfa-method-subtitle">
      Select how you would like to receive your second factor when logging in.
    </Typography>

    <Box className="mfa-method-cards">
      <Card className="mfa-method-card" variant="outlined">
        <CardContent className="mfa-method-card-content">
          <PhoneAndroid className="mfa-method-icon" color="primary" />
          <Typography variant="h6" gutterBottom>
            Authenticator App
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Use Google Authenticator, Authy, Microsoft Authenticator, or any TOTP app. Scan a QR code once and generate
            codes without internet access.
          </Typography>
          <Button variant="contained" color="primary" fullWidth className="mfa-method-btn" onClick={onSelectTotp}>
            Use Authenticator App
          </Button>
        </CardContent>
      </Card>

      <Card className="mfa-method-card" variant="outlined">
        <CardContent className="mfa-method-card-content">
          <Email className="mfa-method-icon" color="secondary" />
          <Typography variant="h6" gutterBottom>
            Email OTP
          </Typography>
          <Typography variant="body2" color="textSecondary">
            A one-time code will be sent to <strong>{userEmail}</strong> each time you log in. No app required — works
            immediately.
          </Typography>
          <Button variant="contained" color="secondary" fullWidth className="mfa-method-btn" onClick={onSelectEmail}>
            Use Email OTP
          </Button>
        </CardContent>
      </Card>
    </Box>

    {onCancel && (
      <Box className="mfa-method-cancel">
        <Button variant="text" onClick={onCancel}>
          Cancel
        </Button>
      </Box>
    )}
  </Box>
);

export default MfaMethodSelector;
